import { Component } from "@angular/core";

import { SvgMixinComponent } from "../svg-mixin.component";

@Component({
  selector: "med-icon-desktop",
  templateUrl: "./med-icon-desktop.component.html",
})
export class MedIconDesktopComponent extends SvgMixinComponent {}
